import Layout from '@/layouts/simple/simpleLayout'

const termsRoutes = [{
  path: '/term',
  component: Layout,
  children: [{
    path: 'agreements',
    name: 'TermAgreements',
    component: () => import('@/views/terms/AffiliateProgramTermsViewerKKdayContent'),
    meta: { skipLoginCheck: true }
  }, {
    path: 'affiliate-sponsor-plan-term',
    name: 'TermAffiliateSponsorPlan',
    component: () => import('@/views/terms/affiliate-sponsor-plan-term'),
    meta: { skipLoginCheck: true }
  }]
}]

export default termsRoutes
